import { styled } from '@linaria/react';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  color?: string;
  children: React.ReactNode;
}

function Spicy({
  color = 'inherit',
  children,
  style = {},
  ...delegated
}: Props) {
  return (
    <Wrapper style={{ color, ...style }} {...delegated}>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.em`
  font-family: var(--font-family-spicy);
  letter-spacing: -0.25px;
  font-style: normal;
  font-weight: 400;
`;

export default Spicy;
